import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import { packApi } from '../api';
import { packKeys } from './pack.keys';

export function useDeletePack(
  options?: UseMutationOptions<void, Error, string>
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...mutationOptions } = options ?? {};
  const mutation = useMutation({
    mutationKey: ['packs', 'delete'],
    mutationFn: packApi.remove,
    ...mutationOptions,
    onSuccess: (_, id, context) => {
      toast({ title: 'Pack excluído com sucesso', variant: 'success' });
      queryClient.invalidateQueries({ queryKey: packKeys.all });
      providedOnSuccess?.(_, id, context);
    },
    onError: (error, variables, context) => {
      toast({
        title: 'Erro ao excluir pack',
        description: error.message,
        variant: 'destructive',
      });
      providedOnError?.(error, variables, context);
    },
  });
  const deletePack = (id: string) => mutation.mutateAsync(id);
  return {
    deletePack,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
